export const ChallengeFilterKeys = [
  "ideaFilter",
  "tagFilter",
  "ideaIncludes",
  "ideaOrder",
  "ideaOrderDirection",
  "ideaPage",
  "ideaFieldChoices",
  "adminHasCommented",
  "customDeadline",
  "projectBoardFilter",
];
